import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../../icons/index';
import './iconButton.scss';
const IconButton = ({ className, onClick, icon, text, fill }) => (_jsxs("button", { className: `icon__button ${className}`, onClick: onClick, children: [_jsx(Icon, { name: icon, fill: fill }), _jsx("span", { children: text })] }));
IconButton.propTypes = {
    className: PropTypes.string,
    fill: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string.isRequired,
    text: PropTypes.string,
};
IconButton.defaultProps = {
    className: '',
    text: '',
    fill: undefined,
};
export default IconButton;
